import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import OsDownloadButton from 'app/components/OSDownloadButton'

interface IAttributes {
  leftButtonWindowsText: string
  leftButtonMacosText: string
  leftButtonAndroidText: string
  leftButtonWindowsUrl: string
  leftButtonWindows7Url: string
  leftButtonMacosUrl: string
  leftButtonAndroidUrl: string
  leftButtoniOSUrl: string
  leftButtoniOSText: string
}

const OsDownloadButtonBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return <OsDownloadButton {...attributes} />
}

export default OsDownloadButtonBlock
